// RotateOverlay (IMPLEMENTATION §3 M7, UX §1.6 "Phone in landscape: full-screen 'Rotate to portrait' overlay.
// The sim keeps running and input is blocked"). Shown by the shell while ui/panels.ts wantsRotate holds; the
// blocking overlays (ErrorScreen, context lost, Elsewhere) win over it.
export interface RotateOverlayProps {
  text: string;
}

export function RotateOverlay({ text }: RotateOverlayProps) {
  return (
    <div class="ov-block ov-rotate" role="dialog" aria-modal="true" data-overlay="rotate">
      <div class="ov-box">
        <div class="ov-phone" aria-hidden="true" />
        <p class="ov-text">{text}</p>
      </div>
    </div>
  );
}
